'use client';

//* Helpers
import { config } from '@/helpers';

//* Components
import Text from '@/components/Text';
import Button from '@/components/Button';

//* Styles
import NotFoundTemplateStyle from './style';

const NotFoundTemplate = () => {
	return (
		<NotFoundTemplateStyle>
			<div className={'not-found-container'}>
				<Text
					className={'h1 not-found-title uppercase align-center'}
					text={'notFoundTitle'}
				/>

				<Text
					className={'p p1 not-found-description align-center'}
					text={'notFoundDescription'}
				/>

				<Button
					text={'goToHomepage'}
					url={config.routes.home.path}
					className={'not-found-button'}
				/>
			</div>
		</NotFoundTemplateStyle>
	);
};

export default NotFoundTemplate;
